module.exports = __webpack_public_path__ + "img/poster-default.d8bb50e5.jpg";